<template>
	<header class="app-bar">
		<Transition appear name="slide-right">
			<div class="left"
				@click="goToHome"
			>
				<img class="logo" src="/images/buzztime.svg" alt="Buzztime Remote"/>
	<!--			<span class="remote">Remote</span>-->
			</div>
		</Transition>
		
		<Transition appear name="slide-left">
			<div class="right">
				<button class="icon-btn" id="pair-btn" title="Pair a TV" @click="showPairingModal = true">
					<Icon name="plus" size="md"/>
				</button>
<!--				<button class="icon-btn"-->
<!--						:title="atPairing ? 'Home' : 'Pair'"-->
<!--						@click="atPairing ? goToHome() : goPair()">-->
<!--					<Icon :name="atPairing ? 'home' : 'plus'" size="md"/>-->
<!--				</button>-->
				<div class="menu">
					<button class="icon-btn" id="profile-btn" aria-label="Menu" @click="toggleMenu">
						<Icon name="profile" size="md"/>
					</button>
					<Transition name="menu">
						<div v-if="menuOpen" class="menu-popup">
		<!--					<button @click="showProfile">Profile</button>-->
							<div class="profile-content" v-if="user">
								<div class="profile-row">
									<span class="value">{{ user.host_site_name }}</span>
								</div>
								
								<div class="profile-row">
									<span class="label">Name:</span>
									<span class="value">{{ user.name || user.display_name }}</span>
								</div>
								<div class="profile-row">
									<span class="label">Site ID:</span>
									<span class="value">{{ user.host_site_id }}</span>
								</div>
								<div class="profile-row">
									<span class="label">Email:</span>
									<span class="value">{{ user.email }}</span>
								</div>
		<!--						<div class="profile-row">-->
		<!--							<span class="label">Role:</span>-->
		<!--							<span class="value text-capitalize">{{ user.role || user.gamehub_role_name }}</span>-->
		<!--						</div>-->
		<!--						<div class="profile-row muted">-->
		<!--							<span class="label">User ID:</span>-->
		<!--							<span class="value">{{ user.id || user.player_id}}</span>-->
		<!--						</div>-->
							</div>
							<button @click="showHelp">Help</button>
							<button class="danger" @click="logout">Logout</button>
						</div>
					</Transition>
				</div>
			</div>
		</Transition>
	</header>
	
	<!-- =====  HELP MODAL  ===== -->
	<Modal
			:show="helpOpen"
			title="Buzztime Customer Service"
			confirm-text="Close"
			cancel-text=""
			:show-footer="true"
			:show-close-button="false"
			@confirm="helpOpen = false"
			@close="helpOpen = false"
	>
		<div class="help-content">
			<!-- live chat -->
<!--			<button class="help-row highlighted" @click="openChat">-->
<!--				<Icon name="chat" size="md"/>-->
<!--				<span class="default">Live Chat</span>-->
<!--			</button>-->
<!--			<button class="help-row highlighted" @click="openChat">-->
<!--				<Icon name="chat" size="md"/>-->
<!--				<span class="default">Live Chat</span>-->
<!--			</button>-->
			
			<!-- phone -->
			<button>
				<a class="help-row" href="tel:+12345640202">
					<Icon name="phone" size="md"/>
<!--					<span>{{ canCall ? 'Call Us' : '+1 (234) 564-0202' }}</span>-->
					<span class="default">Call Us</span>
<!--					<span class="actual">+1 (234) 564-0202</span>-->
				</a>
			</button>
			
			<!-- email -->
			<button>
				<a class="help-row"
				   href="mailto:support@buzztime.com?subject=Buzztime%20Remote%20App%20Support%20Request">
					<Icon name="email" size="md"/>
<!--					<span>{{ canEmail ? 'Email Us' : 'support@buzztime.com' }}</span>-->
					<span class="default">Email Us</span>
<!--					<span class="actual">support@buzztime.com</span>-->
				</a>
			</button>
			
			<!-- web -->
			<button>
				<a class="help-row" href="https://www.buzztime.com" target="_blank" rel="noopener">
					<Icon name="web" size="md"/>
					<span class="default">Visit Website</span>
<!--					<span class="actual">www.buzztime.com</span>-->
				</a>
			</button>
			
			<!-- tutorial -->
			<button>
				<a class="help-row" href="https://www.youtube.com/playlist?list=PLWzwFmUNO31HNrSvmxEKcu4XskiZLtz13"
				   target="_blank" rel="noopener">
					<Icon name="play" size="md"/>
					<span class="default">Watch Tutorials</span>
<!--					<span class="actual">www.buzztime.com/contact-us</span>-->
				</a>
			</button>
		</div>
	</Modal>
	
	<!-- =====  PROFILE MODAL  ===== -->
	<Modal
		:show="profileOpen"
		title="User Profile"
		confirm-text="Close"
		cancel-text=""
		:show-footer="true"
		:show-close-button="false"
		@confirm="profileOpen = false"
		@close="profileOpen = false"
	>
	</Modal>
	
	<!-- Change :confirm-text to 'Pair' : 'hidden' when we want a separate pair command with name/ default app -->
	<Modal
			:show="showPairingModal"
			title="Pair a New Buzztime TV"
			:confirm-text="pairingState?.canSubmit ? 'hidden' : 'hidden'"
			cancel-text="Cancel"
			@close="closePairingModal"
			@cancel="closePairingModal"
			@confirm="handlePairingConfirm"
	>
		<Pairing
				v-if="showPairingModal"
				ref="pairingRef"
				@update:state="pairingState = $event"
				@success="closePairingModal"
		/>
	</Modal>
</template>

<script setup>
import {ref, onMounted, onBeforeUnmount, computed, watch} from 'vue'
import {useRoute, useRouter} from 'vue-router'
import {useMainStore} from '../store/main'
import Icon from "./Icon.vue";
import Modal from "./Modal.vue";
import Pairing from "@/components/Pairing.vue";
// import {useZendesk} from "../utils/zendesk.js";
// import {useZendesk} from "../utils/zendesk.js";

const router = useRouter()
const route = useRoute()
const store = useMainStore()
const menuOpen = ref(false)
const helpOpen = ref(false)
const profileOpen = ref(false)
const user = computed(() => store.user)
// const atPairing = computed(() => route.path === '/pair')
const showPairingModal = ref(false)
const pairingRef = ref(null)
const pairingState = ref({
	isValidated: false,
	isLoading: false,
	canSubmit: false
})

function closePairingModal() {
	showPairingModal.value = false
}

function handlePairingConfirm() {
	if (pairingRef.value) {
		pairingRef.value.saveDetails() // Triggers the save function inside Pairing.vue
	}
}

// const { open } = useZendesk()

// async function goPair() {
// 	await router.push('/pair')
// 	toggleMenu()
// }

function toggleMenu() {
	menuOpen.value = !menuOpen.value
}

function showProfile() {
	// alert('Profile screen coming soon')
	toggleMenu()
	profileOpen.value = true
}

async function logout() {
	toggleMenu()
	await store.logout()
}

function showHelp() {
	toggleMenu()
	helpOpen.value = true
}

async function goToHome() {
	await router.push('/home')
	toggleMenu()
	await store.loadApps()
}

function openChat() {
	open()
	helpOpen.value = false
}

// Check if device can phone/ email. essentially just if its a mobile device or not
// function useDeviceCapabilities() {
// 	const isMobile = computed(() =>
// 			/Android|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i.test(navigator.userAgent)
// 	)
//
// 	// Mobile devices handle tel: natively
// 	const canCall = computed(() => isMobile.value)
//
// 	// Heuristic: mobile likely has a mail app; desktop often doesn't
// 	const canEmail = computed(() => isMobile.value)
//
// 	return {canCall, canEmail, isMobile}
// }
//
// const {canCall, canEmail} = useDeviceCapabilities()

function onDocClick(e) {
	const popup = document.querySelector('.menu-popup')
	const trigger = document.querySelector('.menu > .icon-btn')
	if (!popup || !menuOpen.value) return
	if (!popup.contains(e.target) && !trigger.contains(e.target)) {
		menuOpen.value = false
	}
}

function checkPendingCode() {
	if (sessionStorage.getItem('pending_pairing_code')) {
		// Timeout for animations to finish
		setTimeout(() => {
			// Double check it's still there after the delay
			if (sessionStorage.getItem('pending_pairing_code')) {
				showPairingModal.value = true
			}
		}, 2000)
	}
}

onMounted(() => {
	document.addEventListener('click', onDocClick)
	checkPendingCode()
})

watch(() => route.fullPath, () => {
	checkPendingCode()
})

onBeforeUnmount(() => document.removeEventListener('click', onDocClick))
</script>

<style scoped>
.app-bar {
	position: fixed;
	top: 0;
	left: 0;
	width: 100vw;
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: var(--spacing-lg) var(--spacing-xl);
	z-index: 100;
	/*height: 5rem;*/
	/*height: 10dvh;*/
}

.logo {
	height: 3rem;
	/*width: min(3rem, 8vw);*/
	width: 100%;
}

.right {
	display: flex;
	align-items: center;
	gap: var(--spacing-sm);
	flex-shrink: 0;
}

.left {
	display: flex;
	justify-content: start;
	align-items: center;
	min-width: 0;
	flex-shrink: 1;
	margin-right: var(--spacing-md);
	/*overflow: hidden;*/
}

.icon-btn {
	padding: var(--spacing-md);
	color: var(--color-text);
	border: none;
	background: none;
}

.menu {
	position: relative;
}

.menu-popup {
	position: absolute;
	right: 0;
	gap: var(--spacing-md);
	margin-top: 0.5rem;
	background: var(--color-popup-dark-2);
	backdrop-filter: blur(var(--blur-lg));
	-webkit-backdrop-filter: blur(var(--blur-lg));
	filter: drop-shadow(var(--shadow-lg));
	border: var(--border-thin) var(--color-border);
	border-radius: var(--border-radius-xl);
	padding: var(--spacing-md);
	display: flex;
	flex-direction: column;
	min-width: 10vw;
	max-width: 85vw;
	z-index: 10;
	transform-origin: top right;
	will-change: transform, opacity;
}

.menu-popup button, .help-content button {
	background: var(--color-popup-2);
	color: var(--color-text);
	padding: var(--spacing-md);
	text-align: left;
	border: none;
}

/*.highlighted {*/
/*	scale: 1.07;*/
/*	background: var(--color-popup-light) !important;*/
/*	border: var(--border-thin) var(--color-primary-2) !important;*/
/*}*/

.menu-popup > .danger {
	color: var(--color-error, #ff6b6b);
}

.help-content {
	width: 100%;
	display: grid;
	gap: var(--spacing-md);
	font-size: var(--font-size-base);
}

.help-content a{
	display: flex;
	gap: var(--spacing-md);
	color: var(--color-text);
	text-decoration: none;
}

.help-row{
	display: flex;
	align-items: center;
	gap: var(--spacing-md);
}

.actual {
	font-size: var(--font-size-sm);
	color: var(--color-text-secondary);
	
}

.profile-content {
	display: flex;
	flex-direction: column;
	gap: var(--spacing-sm);
	/*padding: var(--spacing-md) 0;*/
}

.profile-row {
	display: flex;
	justify-content: space-between;
	align-items: center;
	font-size: var(--font-size-base);
	padding: var(--spacing-sm) 0;
	border-bottom: var(--border-thin) var(--color-border);
}

.profile-row .label {
	font-weight: var(--font-weight-semibold);
	color: var(--color-text-secondary);
	margin-right: var(--spacing-sm);
}

.profile-row .value {
	color: var(--color-text);
	text-align: right;
}

.profile-row.muted .value {
	opacity: 0.7;
	font-size: 0.85rem;
}

.text-capitalize {
	text-transform: capitalize;
}


/*.help-row .actual {*/
/*	display: none;*/
/*}*/

/*@media (max-width: 480px) {*/
/*	.help-row:hover .default {*/
/*		display: inline;*/
/*	}*/
/*	*/
/*	.help-row:hover .actual {*/
/*		display: none;*/
/*	}*/
/*}*/
</style>